import { React, Fragment } from "react";
import { TileLayer } from 'react-leaflet';
import {
    useLayers,
  } from '@context';

export const BaseMap = () => {
    //const { darkMode } = useSettings();
    const { baseMap } = useLayers();

    return(
        <Fragment>
           {baseMap && <TileLayer url={baseMap.url}
                      attribution={baseMap.attribution} />}
        </Fragment>
    );
};

export const BaseMap4326 = () => {
    const url = "https://osm.gs.mil/wmts/osm-bright-pc/GLOBAL_PLATECARREE/{z}/{x}/{y}.png";
    const attribution = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

    return(
        <Fragment>
            <TileLayer url={url} attribution={attribution} />
        </Fragment>
    );
};